// extracted by mini-css-extract-plugin
export var actionText = "_o2-4";
export var container = "_o2-0";
export var leftSection = "_o2-1";
export var rightSection = "_o2-2";
export var settingsButton = "_o2-6";
export var settingsIcon = "_o2-7";
export var shortcut = "_o2-5";
export var shortcutGroup = "_o2-3";